import {makeAutoObservable} from "mobx";
import AuthService from "../service/AuthService";
import axios from "axios";

export default class UserStore {
    constructor() {
        this.isAuth = false;
        this.user = {};
        this.theme = localStorage.getItem("theme2318944619") || "light";
        this.openSide = false;
        makeAutoObservable(this);
    }

    setOpenSide(openSide) {
        this.openSide = openSide;
    }

    setIsAuth(bool) {
        this.isAuth = bool;
    }

    setUser(user) {
        this.user = user;
    }

    setTheme() {
        if (this.isAuth) {
            this.theme = this.theme === "light" ? "dark" : "light";
            localStorage.setItem("theme2318944619", this.theme);
        } else this.theme = "light";
    }

    async login(email, password) {
        const response = await AuthService.login(email, password);
        localStorage.setItem("token903573902390236490", response.data.accessToken);
        this.setIsAuth(true);
        this.setUser(response.data.user);
    }

    async register(email, name, password) {
        return await AuthService.register(email, name, password);
    }

    async logout() {
        try {
            await AuthService.logout();
            localStorage.removeItem("token903573902390236490");
            this.setIsAuth(false);
            this.setUser(null);
            this.setTheme();
        } catch (e) {
            alert(`ОКАК: Ошибка выхода из аккаунта - ${e?.response?.data?.message || e}`);
        }
    }

    async deleteAccount(email) {
        try {
            await AuthService.delete(email);
            localStorage.removeItem("token903573902390236490");
            this.setIsAuth(false);
            this.setUser(null);
            this.setTheme();
            alert(`Аккаунт успешно удален`)
        } catch (e) {
            alert(`ОКАК: Ошибка удаления аккаунта - ${e?.response?.data?.message || e}`)
        }
    }

    async checkAuth() {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/user/refresh`, {withCredentials: true});
            localStorage.setItem("token903573902390236490", response.data.accessToken);
            this.setIsAuth(true);
            this.setUser(response.data.user);
        } catch (e) {
            console.log("Пользователь не авторизован")
        }
    }

    async checkHash(hash) {
        return await AuthService.checkHash(hash);
    }

    async forgotPassword(email) {
        return await AuthService.forgotPassword(email);
    }
}